<template>
  <v-col cols="12" class="px-8" v-if="permisoVista('dashboard','r')">
    <v-row>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <datePicker
          v-model="desde"
          format="YYYY-MM-DD"
          :maxDate="fin"
          label="Desde (Obligatorio)"
          clearable
          maxToday
          @input="getMaquinaIns();obtenerDatos()"
          :disabled="cargando"
        ></datePicker>
      </v-col>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <datePicker
          v-model="hasta"
          :minDate="desde"
          format="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          clearable
          maxToday
          @input="getMaquinaIns();obtenerDatos()"
          :disabled="cargando"
        ></datePicker>
      </v-col>
      <v-col cols="4" md="4" sm="4" class="align-self-end">
        <v-autocomplete
					v-model="idTurno"
					:items="turnos"
					item-text="nombre"
					item-value="idTurno"
					label="Turno (Opcional)"
					hide-details
					clearable
					@change="obtenerDatos"
					:disabled="cargando"
				></v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="idsMaquinasIns"
          label="Instancias de Máquinas (Opcional)"
          :items="maquinasIns"
          item-value="idMaquinaIns"
          :item-text="nombreMaquina"
          multiple
          clearable
          dense
          hide-details
          @change="obtenerDatos"
          :disabled="cargando"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="realizarPeticion" class="px-0 ma-0">
      <v-col cols="12" class="ma-0 text-right text-subtitle-2">
        Proxima Actualización en {{tiempo}}
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="cargando"
			color="primary"
			height="5"
			indeterminate
		></v-progress-linear>
    <apexchart type="bar" height="350" @dataPointSelection="dataPointSelectionHandler" :options="chartOptions" :series="series"></apexchart>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-if="seleccion != -1"
          :loading="cargando2"
          :items="datos"
          :headers="headers"
          :page.sync="pagina"
        >

        </v-data-table>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import axios from "axios"

export default {
  props:{
    active:{
      type: Boolean,
      default: false,
    }
  },
  computed:{
    realizarPeticion(){
      if(this.desde != null && this.hasta != null) return true;
      else return false;
      
    },
    url(){
      var url = `/Dashboard/Grafica1?Desde=${this.desde}&Hasta=${this.hasta}`;
      if(this.$utils.isValid(this.idTurno) && this.idTurno > 0) url += `&IdTurno=${this.idTurno}`;
      if(this.idsMaquinasIns.length > 0){
        this.idsMaquinasIns.forEach(idMaquinaIns => {
          url += `&IdsMaquinasIns=${idMaquinaIns}`;
        })
      }
      return url;
    },
    url2(){
      var url = `/Dashboard/Grafica1Ext?Desde=${this.desde}&Hasta=${this.hasta}`;
      if(this.$utils.isValid(this.idTurno) && this.idTurno > 0) url += `&IdTurno=${this.idTurno}`;
      url += `&IdMaquinaIns=${this.categories[this.seleccion].idMaquinaIns}`;
      return url;
    },
    chartOptions(){
      return {
        states: {
          active: {
              allowMultipleDataPointsSelection: false,
          }
        },
        chart: {
          type: 'bar',


          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.categories.map(c => c.nombre),
        },
        yaxis: {
        },
        fill: {
          opacity: 1
        },
        tooltip: {
        }
      }
    },
    tiempo(){
      return this.$utils.strings.toTime(this.segundos);
    }
  },
  data: () => ({
    interval: null,
    segundos: 60,
    cargando: false,
    cargando2: false,
    desde: null,
    hasta:null,
    categories: [],
    series: [],
    seleccion:-1,
    maquinasIns:[],
    idsMaquinasIns: [],
    idTurno: null,
    turnos: [],
    datos:[],
    pagina:1,
    headers:[
      {
        text: "OT",
        align: "center",
        value: "ot",
      },
      {
        text: "Artículo",
        align: "center",
        value: "articulo",
      },
      {
        text: "Aréa",
        align: "center",
        value: "area",
      },
      {
        text: "Cantidad",
        align: "center",
        value: "cantidad",
      },
      {
        text: "Inicio",
        align: "center",
        value: "inicio",
      },
      {
        text: "Fin",
        align: "center",
        value: "fin",
      }
    ]
  }),
  methods:{
    nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    obtenerDatos(){
      if(!this.realizarPeticion || this.cargando) return;

      this.cargando = true;
      this.segundos = 60;

      axios
      .get(this.url)
      .then(response => {
        this.categories = response.data.categories;
        this.series = response.data.series;
        this.cargando = false;
      })
      .catch(error => {
        this.cargando = false;
        console.log(error);
      })
    },
    dataPointSelectionHandler(event, chartContext, config){
      if(this.seleccion == -1){
        this.seleccion = config.dataPointIndex;
        this.getExtraInformacion();
      }
      else if(this.seleccion == config.dataPointIndex){
        this.seleccion = -1;
      }
      else if(this.seleccion != config.dataPointIndex){
        this.seleccion = config.dataPointIndex;
        this.getExtraInformacion();
      }
      
    },
    getExtraInformacion(){
      if(!this.realizarPeticion || this.cargando || this.seleccion < 0) return;
      
      this.cargando2 = true;

      axios
      .get(this.url2)
      .then(response => {
        this.cargando2 = false;
        this.pagina = 1;
        this.datos = response.data;
      })
      .catch(error => {
        this.cargando2 = false;
        console.log(error);
      })
    },
    getMaquinaIns(){
      if(this.desde==null || this.hasta==null){
        this.maquinasIns = [];
        return;
      }
      axios
      .get("/MaquinaInstancias/MaquinasConOperaciones",{
        params:{
          fechaInicio: this.desde,
          fechaFin: this.hasta
        }
      })
      .then(response => {
        this.maquinasIns = response.data;
      })
      .catch(error => {
        console.log(error);
      })
    },
    getTurnos() {
			axios
			.get("/Turnos")
			.then((response) => {
				this.turnos = response.data;
			})
			.catch((error) => {
				console.log(error);
			});
		}
  },
  mounted(){
    this.interval = setInterval(() => {
      if(!this.active) return;

      if(this.segundos == 0) {
        this.obtenerDatos();
        this.getExtraInformacion();
      }
      else this.segundos -= 1;
    },1000);
    this.getTurnos();
  },
  destroyed(){
    clearInterval(this.interval);
  }
}
</script>